import { type InsuranceCorporateIdentity, type WildcardExpression } from "./types";
import { Allianz } from "./private/allianz";
import { AlteOldenburger } from "./private/alte_oldenburger";
import { Axa } from "./private/axa";
import { Barmenia } from "./private/barmenia";
import { Concordia } from "./private/concordia";
import { DEVK } from "./private/devk";
import { DieBayerische } from "./private/die_bayerische";
import { Huk } from "./private/huk";
import { Ottonova } from "./private/ottonova";
import { AkzoNobelBayern } from "./statutory/akzo_nobel_bayern";
import { AOK } from "./statutory/aok";
import { AOKGesamt } from "./statutory/aok_gesamt";
import { AOKPlus } from "./statutory/aok_plus";
import { AudiBKK } from "./statutory/audi_bkk";
import { BahnBKK } from "./statutory/bahn_bkk";
import { Barmer } from "./statutory/barmer";
import { BBraunAesculap } from "./statutory/b_braun_aesculap";
import { BergischeKrankenkasse } from "./statutory/bergische_krankenkasse";
import { BertelsmannBKK } from "./statutory/bertelsmann_bkk";
import { BIG } from "./statutory/big";
import { BkkDiakonie } from "./statutory/bkk_diakonie";
import { BKK24 } from "./statutory/bkk24";
import { BKKDurkoppAdler } from "./statutory/bkk_durkopp_adler";
import { BKKEuregio } from "./statutory/bkk_euregio";
import { BKKExklusiv } from "./statutory/bkk_exklusiv";
import { BKKFaberCastell } from "./statutory/bkk_faber_castell";
import { BKKFirmus } from "./statutory/bkk_firmus";
import { BKKFreudenberg } from "./statutory/bkk_freudenberg";
import { BKKGildemeisterSeidensticker } from "./statutory/BKK_Gildemeister_Seidensticker";
import { BkkHerkules } from "./statutory/bkk_herkules";
import { BKKLinde } from "./statutory/bkk_linde";
import { BKKMelittaHmr } from "./statutory/bkk_melitta_hmr";
import { BKKMTU } from "./statutory/bkk_mtu";
import { BKKPfaff } from "./statutory/bkk_pfaff";
import { BKKPfalz } from "./statutory/bkk_pfalz";
import { BKKPublic } from "./statutory/bkk_public";
import { BKKSalzgitter } from "./statutory/bkk_salzgitter";
import { BKKVdn } from "./statutory/bkk_vdn";
import { BKKVoralb } from "./statutory/bkk_voralb";
import { BMW } from "./statutory/bmw";
import { Bosch } from "./statutory/bosch";
import { Continentale } from "./statutory/continentale";
import { DAK } from "./statutory/DAK";
import { Debeka } from "./statutory/debeka";
import { DeutscheBank } from "./statutory/deutsche_bank";
import { EnergieBkk } from "./statutory/energie_bkk";
import { ErnstYoung } from "./statutory/ernst_young";
import { EVM } from "./statutory/evm";
import { EWE } from "./statutory/ewe";
import { GrozBeckert } from "./statutory/groz_beckert";
import { HeimatKrankenkasse } from "./statutory/heimat-krankenkasse";
import { HEK } from "./statutory/hek";
import { HKK } from "./statutory/hkk";
import { IKK } from "./statutory/ikk";
import { IkkBrandenburgBerlin } from "./statutory/ikk_brandenburg_berlin";
import { IkkClassic } from "./statutory/ikk_classic";
import { IkkGesundPlus } from "./statutory/ikk_gesund_plus";
import { IkkSuedwest } from "./statutory/ikk_suedwest";
import { KarlMayer } from "./statutory/karl_mayer";
import { KKH } from "./statutory/kkh";
import { Knappschaft } from "./statutory/knappschaft";
import { KonigUndBauer } from "./statutory/konig_und_bauer";
import { Krones } from "./statutory/krones";
import { Mahle } from "./statutory/mahle";
import { MercedesBenzBkk } from "./statutory/mercedes_benz_bkk";
import { Merck } from "./statutory/merck";
import { Mhplus } from "./statutory/mhplus";
import { Miele } from "./statutory/miele";
import { MKK } from "./statutory/mkk";
import { MobilKrankenkasse } from "./statutory/mobil_krankenkasse";
import { Novitas } from "./statutory/novitas";
import { Polizei } from "./statutory/polizei";
import { Pronova } from "./statutory/pronova";
import { Provita } from "./statutory/provita";
import { PWC } from "./statutory/pwc";
import { RVBkk } from "./statutory/r_v_bkk";
import { RiekerRicostaWeisser } from "./statutory/rieker_ricosta_weisser";
import { SalusBkk } from "./statutory/salus_bkk";
import { SBH } from "./statutory/sbh";
import { SBK } from "./statutory/sbk";
import { Scheufelen } from "./statutory/scheufelen";
import { Securvita } from "./statutory/securvita";
import { SKD } from "./statutory/skd";
import { SudzuckerBkk } from "./statutory/sudzucker_bkk";
import { SVLFG } from "./statutory/svlfg";
import { TechnikerKrankenkasse } from "./statutory/techniker_krankenkasse";
import { Technoform } from "./statutory/technoform";
import { TuiBkk } from "./statutory/tui_bkk";
import { VerbundPlus } from "./statutory/verbund_plus";
import { Viactiv } from "./statutory/viactiv";
import { VividaBkk } from "./statutory/vivida_bkk";
import { WerraMeissner } from "./statutory/werra_meissner";
import { WirtschaftUndFinanzen } from "./statutory/wirtschaft_und_finanzen";
import { WMF } from "./statutory/wmf";
import { Wurth } from "./statutory/wurth";
import { Zf } from "./statutory/zf";

export const insuranceCorporateIdentities: InsuranceCorporateIdentity[] = [
  // All statutory insurance companies from TSX components
  AkzoNobelBayern,
  AOKGesamt,
  AOKPlus,
  AOK,
  AudiBKK,
  BBraunAesculap,
  BahnBKK,
  Barmer,
  BergischeKrankenkasse,
  BertelsmannBKK,
  BIG,
  BkkDiakonie,
  BKKDurkoppAdler,
  BKKEuregio,
  BKKExklusiv,
  BKKFaberCastell,
  BKKFirmus,
  BKKFreudenberg,
  BKKGildemeisterSeidensticker,
  BkkHerkules,
  BKKLinde,
  BKKMelittaHmr,
  BKKMTU,
  BKKPfaff,
  BKKPfalz,
  BKKPublic,
  BKKSalzgitter,
  BKKVdn,
  BKKVoralb,
  BKK24,
  BMW,
  Bosch,
  Continentale,
  DAK,
  Debeka,
  DeutscheBank,
  EnergieBkk,
  ErnstYoung,
  EVM,
  EWE,
  GrozBeckert,
  HeimatKrankenkasse,
  HEK,
  HKK,
  IkkBrandenburgBerlin,
  IkkClassic,
  IkkGesundPlus,
  IkkSuedwest,
  IKK,
  KarlMayer,
  KKH,
  Knappschaft,
  KonigUndBauer,
  Krones,
  Mahle,
  MercedesBenzBkk,
  Merck,
  Mhplus,
  Miele,
  MKK,
  MobilKrankenkasse,
  Novitas,
  Polizei,
  Pronova,
  Provita,
  PWC,
  RVBkk,
  RiekerRicostaWeisser,
  SalusBkk,
  SBH,
  SBK,
  Scheufelen,
  Securvita,
  SKD,
  SudzuckerBkk,
  SVLFG,
  TechnikerKrankenkasse,
  Technoform,
  TuiBkk,
  VerbundPlus,
  Viactiv,
  VividaBkk,
  WerraMeissner,
  WirtschaftUndFinanzen,
  WMF,
  Wurth,
  Zf,

  // All private insurance companies from TSX components
  Allianz,
  AlteOldenburger,
  Axa,
  Barmenia,
  Concordia,
  Debeka,
  DEVK,
  DieBayerische,
  Huk,
  Ottonova,
];

export const getInsuranceById = (
  id: string
): InsuranceCorporateIdentity | undefined => {
  return insuranceCorporateIdentities.find((insurance) => insurance.id === id);
};

export const getInsuranceByWildcard = (
  searchTerm: string
): InsuranceCorporateIdentity[] => {
  const term = searchTerm.toLowerCase();

  const matches = (expr: WildcardExpression): boolean => {
    if (typeof expr === "string") return term.includes(expr.toLowerCase());
    if ("and" in expr)
      return expr.and.every((e: WildcardExpression) => matches(e));
    if ("or" in expr)
      return expr.or.some((e: WildcardExpression) => matches(e));
    return false;
  };

  return insuranceCorporateIdentities.filter((insurance) => {
    const match =
      matches(insurance.wildcard) ||
      insurance.name.toLowerCase().includes(term);
    return match;
  });
};

export const getInsurancesByType = (
  type: "statutory" | "private"
): InsuranceCorporateIdentity[] => {
  return insuranceCorporateIdentities.filter(
    (insurance) => insurance.type === type
  );
};
